import { Injectable } from '../injector/decorators'
import { UserApiService } from './UserApiService'

@Injectable()
export class LegacyPhoneVerificationService extends UserApiService {
	startPhoneVerification(req: InternationalPhoneNumber): Promise<PhoneVerificationResponse> {
		return this.httpPost<InternationalPhoneNumber, PhoneVerificationResponse>(
			'/phone-verification/start',
			req,
		).toPromise()
	}

	checkVerificationCode(req: CheckVerificationCodeRequest): Promise<CheckVerificationCodeResponse> {
		return this.httpPost<{}, CheckVerificationCodeResponse>('/phone-verification/check', req).toPromise()
	}

	checkCustomerStatus(): Promise<CustomerStatusResponse> {
		return this.httpGet<CustomerStatusResponse>('/phone-verification/status').toPromise()
	}
}
